/**
 *  基于 VUE + Element 的常用 函数 封装
 *  @Data 2020-12-12 ~ 至今
 *  @Author:zf;
 *  @mailbox:546558392@qq.com;
 */
let tools = {}


/**
 * 查询当前用户是否有操作权限
 */
tools.hasResource=function(id){
    let requests =JSON.parse(sessionStorage.getItem("loginUser"))
    if(requests.account===null){
        return false
    }
    for(let i=0;i<requests.functionList.length;i++){
        if(id===requests.functionList[i].id){
            return true
        }
    }
    return false
}

tools.hasLabel =function(){
    let requests =JSON.parse(sessionStorage.getItem("loginUser"))
    if(requests.account===null){
        return false
    }
    if (requests.parentId==="tianmaobuxin"){
        return true
    }
    if (requests.agentId==="tianmaobuxin"){
        return true
    }
    if (requests.agentId==="zy0000"){
        return true
    }
    return false
}






//-----[验证文本并提示]
tools.VerificationsText = function (_this, _val, Message) {
    //console.log(_val);
    let bool = tools.Is_null(_val);
    //console.log(bool);
    if (bool == false) {
        tools.open(_this, Message)
    }
    return bool;
}

//-----[验证文本并提示]
tools.VerificationsText_wx = function (_this, _val, Message) {
    //console.log(_val);
    let bool = tools.Is_null(_val);
    //console.log(bool);
    if (bool == false) {
        _this.$notify.error(Message);
    }
    return bool;
}


//-----[验证数组并提示]
tools.VerificationsArr = function (_this, _arr, Message) {
    let bool = _arr.length>0;
    if (bool == false) {
        tools.open(_this, Message)
    }
    return bool;
}
/**
 * 判断是否为空值
 * @param val
 * @returns
 */
tools.Is_null = function (val) {
    //console.log(val)
    //console.log(val)
    //console.log(Object.is(val, NaN))
    if(Object.is(val, NaN)){
        //console.log("fffffff")
        return  false;
    }else{
        val = tools.isNumber(val) == true ? val + "" : val;//如果是一个数字类型过滤成字符串 && isNaN(val)==false
        return val != undefined && val != null  && val.trim() != "" && val != "undefined" && val != "null" && val != 'NaN'? true : false;
    }
}


/**
 * 通道接口调用时 计算 Sign
 * @param _this
 * @param map
 * @param key
 * @returns {string}
 */
tools.getSign = function (_this,map, key) {
    // console.log("getSign====")
    let signstr = "";
    let key_arr = [];
    $.each(map, function (key, val) {
        key_arr.push(key)
    })
    //console.log(key_arr)
    key_arr.sort();
    //console.log(key_arr)
    $.each(key_arr, function (i, o) {
        signstr += o + "=" + map.o + "&";
    })
    signstr = "key=" + key;
    //console.log(signstr);
    let sign = _this.$md5(signstr).toUpperCase();
    // console.log(sign);
    return sign;
}

/**
 * obj 判断是否是一个数（number）
 * @param obj
 * @returns
 */
tools.isNumber = function (obj) {
    return typeof obj === 'number' && !isNaN(obj);
}



















/**
 * toFixed(四舍五入重写)
 * @param number
 * @param decimal
 * @returns
 */
tools.toFixed = function (number, decimal) {
    decimal = decimal || 0;
    let s = String(number);
    let decimalIndex = s.indexOf('.');
    if (decimalIndex < 0) {
        let fraction = '';
        for (let i = 0; i < decimal; i++) {
            fraction += '0';
        }
        return s + '.' + fraction;
    }
    let numDigits = s.length - 1 - decimalIndex;
    if (numDigits <= decimal) {
        let fraction = '';
        for (let i = 0; i < decimal - numDigits; i++) {
            fraction += '0';
        }
        return s + fraction;
    }
    let digits = s.split('');
    let pos = decimalIndex + decimal;
    let roundDigit = digits[pos + 1];
    if (roundDigit > 4) {
        //跳过小数点
        if (pos == decimalIndex) {
            --pos;
        }
        digits[pos] = Number(digits[pos] || 0) + 1;
        //循环进位
        while (digits[pos] == 10) {
            digits[pos] = 0;
            --pos;
            if (pos == decimalIndex) {
                --pos;
            }
            digits[pos] = Number(digits[pos] || 0) + 1;
        }
    }
    //避免包含末尾的.符号
    if (decimal == 0) {
        decimal--;
    }
    return digits.slice(0, decimalIndex + decimal + 1).join('');
}


/**
 * 针对文本域 换行符切割 过滤前后空格获取数组
 * @param lets
 */
tools.textareaGet = function (vars){
    vars = vars.split(/[\s\n]/);
    let arr=new Array()
    vars.map((item,index)=>{
        if(item!=""){
            arr.push(item.replace(/\s+/g,""))
        }
    })
    return arr;
}

tools.getdateAll =function (begin, end) {
    let $resdata = [];
    let ab = begin.split("-");
    let ae = end.split("-");
    let db = new Date();
    db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
    let de = new Date();
    de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
    let unixDb = db.getTime();
    let unixDe = de.getTime();
    for(let k = unixDb; k <= unixDe;) {
        $resdata.push(new Date(parseInt(k)));
        k = k + 24 * 60 * 60 * 1000;
    }
    return $resdata;
}

tools.formatNum =function (str) {
    let newStr = "";
    let count = 0;
    str = str+"";
    //console.log(str)
    // 当数字是整数
    if (str.indexOf(".") === -1) {
        for (let i = str.length - 1; i >= 0; i--) {
            if (count % 3 === 0 && count !== 0) {
                newStr = str.charAt(i) + "," + newStr;
            } else {
                newStr = str.charAt(i) + newStr;
            }
            count++;
        }
        str = newStr ; //自动补小数点后两位
        return str;
    }
    // 当数字带有小数
    else {
        for (let i = str.indexOf(".") - 1; i >= 0; i--) {
            if (count % 3 === 0 && count !== 0) {
                newStr = str.charAt(i) + "," + newStr;
            } else {
                newStr = str.charAt(i) + newStr; //逐个字符相接起来
            }
            count++;
        }
        str = newStr + (str + "00").substr((str + "00").indexOf("."), 3);
        return str;
    }
}

//----[获取当前日期]
tools.gitData =function () {
    function p(s) {
        return s < 10 ? '0' + s : s;
    }
    let myDate = new Date();
    //获取当前年
    let year = myDate.getFullYear();
    //获取当前月
    let month = myDate.getMonth() + 1;
    //获取当前日
    let date = myDate.getDate();
    return(year + '-' + p(month) + "-" + p(date));
}

//-----[获取当前时间]
tools.getdatetime =function () {
    let myDate = new Date();
    //获取当前年
    let year = myDate.getFullYear();
    //获取当前月
    let month = myDate.getMonth() + 1;
    //获取当前日
    let date = myDate.getDate();
    let h = myDate.getHours(); //获取当前小时数(0-23)
    let m = myDate.getMinutes(); //获取当前分钟数(0-59)
    let s = myDate.getSeconds();
    let now = year + '-' +tools.p(month) + "-" + tools.p(date) + " " + tools.p(h) + ':' + tools.p(m) + ":" + tools.p(s);

    return now;
}

tools.p =function (s) {
    return s < 10 ? '0' + s : s;
}


//-----[获取前n天的日期]
tools.getBeforeDate =function (n) {

    let d = new Date();
    let year = d.getFullYear();
    let mon = d.getMonth() + 1;
    let day = d.getDate();
    if(day <= n) {
        if(mon > 1) {
            mon = mon - 1;
        } else {
            year = year - 1;
            mon = 12;
        }
    }
    d.setDate(d.getDate() - n);
    year = d.getFullYear();
    mon = d.getMonth() + 1;
    day = d.getDate();
    let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
    return s;
}







//----[多少毫秒后刷新界面]
tools.loadSX = function (s) {
    setTimeout(function() {
        window.location.reload();
    }, s);
}
//----[多少毫秒后刷新界面]


/**
 * obj 判断是否是一个数（number）
 * @param obj
 * @returns
 */
tools.isNumber = function   (obj){
    return   typeof obj === 'number' && !isNaN(obj);
}



export default tools